// Retries a Firestore-calling function if it fails with
// "permission-denied" — this can happen for a few seconds right after
// login or a first-time OTP claim, because the company_id custom claim
// is committed server-side by an async Cloud Function (syncUserClaims)
// with real latency, so the very first company_id-scoped query issued
// right after login can race ahead of that commit. Forcing a fresh ID
// token isn't always enough on its own, because a fresh token still
// can't contain a claim that genuinely hasn't been committed
// server-side yet — a short wait-and-retry is what actually closes
// this gap (12 Aug 2026 audit — same root cause recurring across
// AuthContext.jsx, Dashboard.js, useNotifications.js, and
// TechnicianDashboard.jsx).
export async function retryOnPermissionDenied(fn, { attempts = 3, delayMs = 600 } = {}) {
  let lastErr;
  for (let i = 0; i < attempts; i++) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      if (err?.code !== "permission-denied") throw err;
      if (i < attempts - 1) {
        await new Promise(res => setTimeout(res, delayMs));
      }
    }
  }
  throw lastErr;
}